import LanguageSelector from "@/components/languageSelector/LanguageSelector";
import PspButton from "@/components/pspButton/PspButton";
import PspLogo from "@/components/pspLogo/PspLogo";
import PspTextInput from "@/components/pspTextInput/pspTextInput";
import { translate, TranslatorKeys } from "@/config/translator";
import { Text } from "@fluentui/react-components";
import { useNewPassword } from "./newPassword/useNewPassword";
// eslint-disable-next-line max-len
import { PasswordRequirementItem } from "@/components/passwordRequirementItem/passwordRequirementItem";

type NewPasswordProps = {
  email: string;
  code: string;
  onPreviousStage: () => void;
};

export function NewPassword({
  email,
  code,
  onPreviousStage,
}: NewPasswordProps) {
  const {
    onKeyDownConfirmPassword,
    onKeyDownPassword,
    onSubmitNewPassword,
    setConfirmPassword,
    errorMessage,
    passwordRequirements,
    password,
    confirmPassword,
    lang,
    confirmPasswordInputRef,
    changePasswordButtonRef,
    onChangePassword,
    invalidPassword,
  } = useNewPassword({ email, code });

  return (
    <div className="fixed inset-0 justify-center items-center flex bg-white flex-col gap-8">
      <div className="absolute top-16 tablet:top-20 w-full flex flex-row justify-center">
        <PspLogo />
      </div>

      {/* LANGUAGE SELECTOR */}
      <div className="absolute top-36 tablet:top-10 tablet:right-10">
        <LanguageSelector />
      </div>
      <div className="w-2/3 tablet:w-1/2 desktop:w-1/3 flex-col flex gap-4">
        <div className="relative w-full flex flex-row justify-center">
          <div className="absolute bottom-10 tablet:bottom-15">
            <Text className="text-warning">
              {errorMessage ? translate(errorMessage, lang) : ""}
            </Text>
          </div>
        </div>

        {/* PASSWORD */}
        <PspTextInput
          onKeyDown={onKeyDownPassword}
          onChange={onChangePassword}
          value={password}
          label="newPassword"
          type="password"
        />

        {/* CONFIRM PASSWORD */}
        <PspTextInput
          onKeyDown={onKeyDownConfirmPassword}
          onChange={setConfirmPassword}
          value={confirmPassword}
          label="confirmNewPassword"
          type="password"
          ref={confirmPasswordInputRef}
        />

        <div className="flex flex-col gap-2">
          <PasswordRequirementItem isSatisfied={password === confirmPassword}>
            {translate("passwordsMatch", lang)}
          </PasswordRequirementItem>
          {Object.entries(passwordRequirements).map(([policyError, error]) => (
            <PasswordRequirementItem isSatisfied={!error}>
              {translate(("password_" + policyError) as TranslatorKeys, lang)}
            </PasswordRequirementItem>
          ))}
        </div>

        <div className="w-full flex flex-row justify-end gap-4">
          {/* BACK BUTTON */}
          <PspButton onClick={onPreviousStage} size="large">
            {translate("back", lang)}
          </PspButton>

          {/* CHANGE PASSWORD BUTTON */}
          <PspButton
            appearance="primary"
            onClick={onSubmitNewPassword}
            size="large"
            customRef={changePasswordButtonRef}
            disabled={invalidPassword}
          >
            {translate("changePassword", lang)}
          </PspButton>
        </div>
      </div>
    </div>
  );
}
